const pad = (n: number) => String(n).padStart(2, "0");

const LAUNCH = Date.UTC(2027, 1, 6, 23, 0, 0);

export function initCountdown(reduced: boolean): void {
  const root = document.querySelector<HTMLElement>("[data-countdown]");
  if (!root) return;
  const cells = {
    d: root.querySelector<HTMLElement>('[data-cd="d"]'),
    h: root.querySelector<HTMLElement>('[data-cd="h"]'),
    m: root.querySelector<HTMLElement>('[data-cd="m"]'),
    s: root.querySelector<HTMLElement>('[data-cd="s"]'),
  };

  const write = (el: HTMLElement | null, text: string) => {
    if (!el || el.textContent === text) return;
    el.textContent = text;
    if (reduced) return;
    el.classList.remove("is-tick");
    void el.offsetWidth;
    el.classList.add("is-tick");
  };
  const tick = () => {
    const now = new Date();
    const left = Math.max(0, Math.floor((LAUNCH - now.getTime()) / 1000));
    write(cells.d, pad(Math.floor(left / 86400)));
    write(cells.h, pad(Math.floor((left % 86400) / 3600)));
    write(cells.m, pad(Math.floor((left % 3600) / 60)));
    write(cells.s, pad(left % 60));
    window.setTimeout(tick, 1000 - now.getMilliseconds() + 5);
  };
  tick();
}
